import { request } from 'shared/api/axios';

import { readErrorMessage } from './pdfResponse';

/**
 * 로그인한 회원 본인의 PDF 문서를 받아 파일로 저장한다.
 * 서버는 실패도 HTTP 200 + JSON 으로 내려주므로 응답 타입으로 성공 여부를 가른다.
 */
export const downloadPdf = async (path: string, filename: string): Promise<void> => {
  const response = await request.get<Blob>(path, {
    responseType: 'blob',
    headers: { Accept: 'application/pdf, application/json' },
    timeout: 60000,
  });

  const contentType = String(response.headers['content-type'] ?? '');
  if (!contentType.includes('application/pdf')) {
    throw new Error((await readErrorMessage(response.data)) ?? 'Failed to download the document.');
  }

  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
